import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/hesabim")({
  head: () => ({
    meta: [
      { title: pageTitle("Hesabım", "tr") },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AccountPage,
});

function AccountPage() {
  const { user, loading, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate({ to: "/login" });
  }, [loading, user, navigate]);

  if (loading || !user) {
    return <div className="max-w-md mx-auto px-6 py-20 text-sm text-ink/60">Yükleniyor…</div>;
  }

  const meta = (user.user_metadata ?? {}) as Record<string, unknown>;
  const fullName = (meta.full_name as string) || (meta.name as string) || "";

  const handleSignOut = async () => {
    await signOut();
    navigate({ to: "/" });
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <h1 className="font-serif text-4xl mb-2">Hesabım</h1>
      <p className="text-sm text-ink/60 mb-8">Üyelik bilgileriniz.</p>

      <div className="space-y-3 text-sm border border-border rounded-xl p-5 mb-8">
        {fullName && (
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-ink/60">Ad</div>
            <div>{fullName}</div>
          </div>
        )}
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-ink/60">E-posta</div>
          <div>{user.email}</div>
        </div>
      </div>

      <button
        onClick={handleSignOut}
        className="w-full py-2.5 bg-ink text-paper rounded-full text-sm uppercase tracking-[0.2em] font-medium"
      >
        Çıkış Yap
      </button>

      <div className="mt-10 text-xs text-ink/85">
        <Link to="/">← Anasayfaya dön</Link>
      </div>
    </div>
  );
}
